<template>
  <ul class="repeater--vuejs">
    <li v-for="index in parseInt(maximum, 10)" :key="index" :class="classeLi(index)"></li>
  </ul>
</template>

<script>
export default {
  name: 'Repeater',
  props: ['courant', 'maximum', 'liCssCustom'],
  methods: {
    classeLi(index) {
      let css = 'repeater';
      if (index < parseInt(this.courant, 10)) {
        css += this.liCssCustom + ' active';
      } else if (index === parseInt(this.courant, 10)) {
        css += this.liCssCustom + ' active courante';
      } else {
        css += this.liCssCustom;
      }
      if (index === parseInt(this.maximum, 10)) {
        css += ' dernier';
      }
      return css;
    },
  },
}
</script>

<style scoped>
ul.repeater--vuejs {
  width: 100%;
  margin-bottom: .5em;
}

.toolbox ul.repeater--vuejs > li,
ul.repeater--vuejs > li {
  background-color: #e7ebbb;
  display: inline-block;
  list-style-type: none;
  min-width: 8.24%;
  width: 8.24%;
  height: 0.25em;
  margin-right: 0.1%;
}

.toolbox ul.repeater--vuejs > li.active,
ul.repeater--vuejs > li.active {
  background-color: #b0bd32;
}

.toolbox ul.repeater--vuejs > li.dernier,
ul.repeater--vuejs > li.dernier {
  margin-right: 0px;
}

.toolbox ul.repeater--vuejs > li::before,
ul.repeater--vuejs > li::before {
  content: none;
}
</style>